import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { TraitsApi, VehiclesApi } from "../api/AdminApi";
import { getData, postFormData } from "../api/AuthenticatedApiCaller";
import OperationResult from "../commons/OperationResult";
import VehicleMediaCard from "../commons/VehicleMediaCard";
import VehicleTraitSelect from "./VehicleTraitSelect";

export function VehicleAddDialog(props) {
  const [hasError, setHasError] = useState(null);
  const [traitMap, setTraitMap] = useState(null);

  const [image, setImage] = useState(null);
  useEffect(() => {
    if (traitMap === null) {
      fetchData();
    }
  }, []);

  async function fetchData() {
    const [data, error] = await getData(TraitsApi.getVehicleTraitInfo);
    if (error) {
      // Handle the error
    } else {
      setTraitMap(data["traitMap"]);
    }
  }

  const updatedVehicle =
    props.vehicle !== null
      ? JSON.parse(JSON.stringify(props.vehicle))
      : {
          title: "",
          rate: 0,
          currentRate: 0,
          traitIds: [],
          traitMap: {},
          active: false,
          imageUrl: "",
          replaceImage: false,
          pricesPerMonth: {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            6: 0,
            7: 0,
            8: 0,
            9: 0,
            10: 0,
            11: 0,
            12: 0,
          },
        };

  async function save() {
    updatedVehicle.replaceImage = image === null ? false : true;
    updatedVehicle.traitIds = Object.values(updatedVehicle.traitMap).filter(
      (id) => id !== 0
    );

    let formData = new FormData();
    let jsonAsBlob = new Blob([JSON.stringify(updatedVehicle)], {
      type: "application/json",
    });

    formData.append("vehicle", jsonAsBlob);
    formData.append("image", image);

    let [data, error] = await postFormData(VehiclesApi.set, formData);
    if (!error) {
      setHasError(false);
    } else {
      setHasError(true);
    }
    props.save();
  }

  const addImage = (e) => {
    console.log(e);
    setImage(e);
    updatedVehicle.replaceImage = true;
    //setImg(e.target.files[0]);
  };

  return (
    <Box>
      {hasError !== null && <OperationResult success={!hasError} />}

      <Dialog open={props.open}>
        <DialogTitle>Edit Vehicle</DialogTitle>
        <DialogContent>
          <Stack
            sx={{ width: "100%", height: "100%" }}
            component="paper"
            spacing={4}
          >
            <Typography variant="h7">Basic Information</Typography>
            <TextField
              defaultValue={updatedVehicle.title}
              label="Title"
              onChange={(event) => {
                updatedVehicle.title = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.rate}
              label="Rate"
              onChange={(event) => {
                updatedVehicle.rate = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.currentRate}
              label="Current Rate"
              onChange={(event) => {
                updatedVehicle.currentRate = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["1"]}
              label="January Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["1"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["2"]}
              label="February Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["2"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["3"]}
              label="March Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["3"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["4"]}
              label="April Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["4"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["5"]}
              label="May Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["5"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["6"]}
              label="June Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["6"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["7"]}
              label="July Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["7"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["8"]}
              label="August Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["8"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["9"]}
              label="September Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["9"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["10"]}
              label="Octomber Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["10"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["11"]}
              label="November Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["11"] = event.target.value;
              }}
            />

            <TextField
              defaultValue={updatedVehicle.pricesPerMonth["12"]}
              label="December Rate"
              onChange={(event) => {
                updatedVehicle.pricesPerMonth["12"] = event.target.value;
              }}
            />

            <Typography variant="h7">Traits</Typography>
            {traitMap !== null && (
              <React.Fragment>
                <VehicleTraitSelect
                  type="FUEL"
                  traits={traitMap["FUEL"]}
                  changeTrait={(traitValue) => {
                    updatedVehicle.traitMap["FUEL"] = traitValue;
                  }}
                  currentTraitId={updatedVehicle.traitMap["FUEL"]}
                />

                <VehicleTraitSelect
                  type="PASSENGERS"
                  traits={traitMap["PASSENGERS"]}
                  changeTrait={(traitValue) => {
                    updatedVehicle.traitMap["PASSENGERS"] = traitValue;
                  }}
                  currentTraitId={updatedVehicle.traitMap["PASSENGERS"]}
                />

                <VehicleTraitSelect
                  type="DOORS"
                  traits={traitMap["DOORS"]}
                  changeTrait={(traitValue) => {
                    updatedVehicle.traitMap["DOORS"] = traitValue;
                  }}
                  currentTraitId={updatedVehicle.traitMap["DOORS"]}
                />

                <VehicleTraitSelect
                  type="TRANSMISSION"
                  traits={traitMap["TRANSMISSION"]}
                  changeTrait={(traitValue) => {
                    updatedVehicle.traitMap["TRANSMISSION"] = traitValue;
                  }}
                  currentTraitId={updatedVehicle.traitMap["TRANSMISSION"]}
                />

                <VehicleTraitSelect
                  type="AC"
                  traits={traitMap["AC"]}
                  changeTrait={(traitValue) => {
                    updatedVehicle.traitMap["AC"] = traitValue;
                  }}
                  currentTraitId={updatedVehicle.traitMap["AC"]}
                />

                <VehicleTraitSelect
                  type="LUGGAGE"
                  traits={traitMap["LUGGAGE"]}
                  changeTrait={(traitValue) => {
                    updatedVehicle.traitMap["LUGGAGE"] = traitValue;
                  }}
                  currentTraitId={updatedVehicle.traitMap["LUGGAGE"]}
                />
              </React.Fragment>
            )}
            <VehicleMediaCard
              imageUrl={updatedVehicle.imageUrl}
              callback={addImage}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={save}>Save</Button>
          <Button onClick={props.cancel} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
